import React from 'react';
import { motion } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const PageTemplate = ({ title, subtitle, children }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Video Hero Section */}
      <div className="h-screen w-full relative overflow-hidden" style={{ minHeight: '100vh', paddingBottom: '80px' }}>
        <video
          className="absolute top-1/2 left-1/2 w-full h-full object-cover transform -translate-x-1/2 -translate-y-1/2"
          src="/fenfakultesivideo.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 md:px-16 max-w-5xl mx-auto w-full">
          <motion.h1
            className="font-black text-white uppercase leading-tight break-words w-full"
            style={{
              fontSize: title.length > 80
                ? 'clamp(1.2rem, 2.2vw + 0.4rem, 2.2rem)'
                : title.length > 50
                ? 'clamp(1.5rem, 3vw + 0.4rem, 3rem)'
                : 'clamp(1.8rem, 4vw + 0.5rem, 3.75rem)',
              textShadow: '0px 4px 24px rgba(0,0,0,0.7)',
            }}
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p
              className="mt-5 text-base md:text-lg text-white/80 font-light max-w-2xl leading-relaxed"
              style={{ textShadow: '0px 2px 10px rgba(0,0,0,0.5)' }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            >
              {subtitle}
            </motion.p>
          )}
        </div>
        
        {/* Animated Scroll Down Indicator */}
        <motion.div 
          className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center cursor-pointer group"
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-sm font-medium text-white/80 tracking-widest uppercase group-hover:text-white transition-colors duration-300">
            {t('common.scrollDown')}
          </span>
          <FaChevronDown className="w-6 h-6 mt-2 text-white animate-bounce" />
        </motion.div>
      </div>

      {/* Page Content */}
      <div className="relative bg-gray-50 -mt-20 rounded-t-3xl pt-16 pb-20 z-20">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-10 lg:p-12">
                 {children || <p className="text-gray-700">{t('common.pageComingSoon')}</p>}
            </div>
        </div>
      </div>
    </>
  );
};

export default PageTemplate; 